var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row header align-items-center", class: _vm.containerClass },
    [
      _vm.showBackButton
        ? _c("back-button", { attrs: { "static-route": _vm.staticBackRoute } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.size },
        [
          _vm.$slots.title
            ? _vm._t("title")
            : _c("h2", { class: _vm.titleClass }, [
                _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
              ]),
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("inlinebuttons"),
      _vm._v(" "),
      _vm.subtitle
        ? _c("div", { class: _vm.size }, [
            _c("h6", { staticClass: "grey-text text-darken-1" }, [
              _vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("buttons"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }